<template>
  <!-- Slider main container -->
  <div class="swiper swiper-beforeAfterWrapper" data-aos="fade-up">
    <div class="swiper-wrapper">
      <patient-before-after v-for="entry in entries" :key="entry.image" :entry="entry" :section="section"></patient-before-after>
    </div>

    <SwiperControls />
  </div>
</template>

<script>
import SwiperControls from '../partials/swiper-controls-partials.vue'

export default {
  components: {
    SwiperControls
  },
  setup() {
    return {}
  },
  props: ['entries', 'section'],
}
</script>